"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 300px;\n  height: 100%;\n  background-color: ", ";\n  padding: 15px;\n  overflow: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 500;\n\n  .versions-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .buttons-container {\n      display: flex;\n      align-items: center;\n\n      button + * {\n        margin-left: 10px;\n      }\n    }\n  }\n"])), _variables.GlobalColors.deep_gray);

exports.Container = Container;